// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteEngineCompartmentApiKeyModal_dialog__2f52E"};